module.exports = __webpack_public_path__ + "img/user-03.0fc73648.jpg";